import QR from "../assets/images/QR.png";
import BackGroundImage from "../assets/images/kunji_bg.png";
import kunji_main from "../assets/images/kunji_main.png";
import { features } from "../constant";
import Description from "./Description";
import SEO from "./SEO";

const Kunji = () => {
  return (
    <section className="relative w-full">
      <SEO
        title="Kunji - AI Study Assistant | Schooglink"
        description="Kunji AI-powered study assistant by Schooglink. Get instant doubt solving, personalized learning support for Bihar Board, UP Board exams in Hindi."
        url="https://schooglink.com/kunji"
      />
      {/* Background */}
      <div
        className="absolute top-0 left-0 w-full rounded-b-3xl overflow-hidden"
        style={{
          height: "calc(100px + 800px + 900px)",
          backgroundImage: `url(${BackGroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: -10,
        }}
      />

      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 pt-16 sm:pt-24 lg:pt-32 xl:pt-40">
        {/* Top Section */}
        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-10 lg:gap-24">
          {/* Text */}
          <div className="flex-1">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Schooglink delivers <b>AI powered, vernacular education for K-12</b>
            </h2>

            <p className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl leading-relaxed mb-8 text-gray-700 font-semibold">
              Our AI solution, <b>“Kunji”</b>, uses generative multimodal LLMs with
              a RAG engine on top of our massive vernacular content IP for K-12,
              covering multiple State Boards and CBSE curricula in Hindi, English,
              and Hinglish.
              <br />
              This includes 20,000+ videos, 1,00,000+ questions, and 5000+ test papers.
              <br />
              <br />
              Our content experts ensure minimal hallucinations for students.
            </p>

            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 sm:gap-12">
              <div className="text-center sm:text-left">
                <div className="font-bold text-3xl sm:text-4xl py-2">Kunji कुंजी</div>
                <b className="text-xl sm:text-2xl">Powered by AI, Driven by Curiosity!</b>
                <br />
                <b className="text-2xl sm:text-3xl text-[#ff6f00] py-2">
                  घंटों की पढ़ाई मिनटों में, AI के साथ!
                </b>
                <br />
                <a
                  href="https://play.google.com/store/apps/details?id=com.schooglink.curriculum.pathcharya"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Get Kunji on Google Play"
                  className="inline-block mt-3"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Get it on Google Play"
                    className="h-12 sm:h-14 hover:opacity-90 transition"
                    loading="lazy"
                  />
                </a>
              </div>

              <img
                src={QR}
                alt="Kunji QR Code"
                className="h-32 w-32 sm:h-40 sm:w-40"
                loading="lazy"
              />
            </div>
          </div>

          {/* Kunji Image */}
          <div className="flex-1 flex justify-center lg:justify-end mt-8 lg:mt-0">
            <img
              src={kunji_main}
              alt="Kunji Main Graphic"
              className="max-h-[400px] sm:max-h-[500px] lg:max-h-[543px] w-auto max-w-[90%] sm:max-w-[450px] object-contain"
              loading="lazy"
            />
          </div>
        </div>

        {/* Why Kunji */}
        <div className="mt-16 sm:mt-24 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">Why Kunji?</h2>
          <Description />
        </div>

        {/* Features Section */}
        <div className="mt-12 sm:mt-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
            {features.map((feature, idx) => (
              <article
                key={idx}
                className={`flex flex-col items-center justify-center text-center p-5 rounded-xl shadow-md ${feature.bg} h-[280px] sm:h-[300px] w-full hover:scale-[1.02] transition-transform duration-300 focus-within:ring-2 focus-within:ring-blue-500 hover:bg-white`}
                tabIndex={0}
                aria-label={feature.title}
              >
                <h3 className={`text-lg sm:text-xl font-bold mb-6 ${feature.titlecolor}`}>
                  {feature.title}
                </h3>
                <p className={`text-base sm:text-lg ${feature.desccolor}`}>
                  {feature.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Kunji;
